export { default } from './support-v2-category-page';
